import React from 'react';
import Shortcuts from '@atlassian/jira-common-components-keyboard-shortcuts/src/shortcuts';
import { useDateFilter, RelativeDateFilterOptions } from '../../../controllers/date-filter';

type Props = {
	onKeyPress: (dateFilterType: string) => void;
};

const KeyboardShortcuts = ({ onKeyPress }: Props) => {
	const [, { setRelativeDateFilter }] = useDateFilter();

	const keyMap = {
		m: {
			callback: () => {
				setRelativeDateFilter(RelativeDateFilterOptions.PAST_MONTH);
				onKeyPress(RelativeDateFilterOptions.PAST_MONTH.toLowerCase());
			},
		},
		q: {
			callback: () => {
				setRelativeDateFilter(RelativeDateFilterOptions.PAST_QUARTER);
				onKeyPress(RelativeDateFilterOptions.PAST_QUARTER.toLowerCase());
			},
		},
		w: {
			callback: () => {
				setRelativeDateFilter(RelativeDateFilterOptions.PAST_TWO_WEEKS);
				onKeyPress(RelativeDateFilterOptions.PAST_TWO_WEEKS.toLowerCase());
			},
		},
		y: {
			callback: () => {
				setRelativeDateFilter(RelativeDateFilterOptions.PAST_YEAR);
				onKeyPress(RelativeDateFilterOptions.PAST_YEAR.toLowerCase());
			},
		},
	};

	return <Shortcuts keyMap={keyMap} />;
};

export default KeyboardShortcuts;
